// removed by extract-text-webpack-plugin
module.exports = {"previewImage":"styles__previewImage__1qe73","rightMargin":"styles__rightMargin__3eC4O","verticalCenterChildren":"styles__verticalCenterChildren__130I3","saveButtons":"styles__saveButtons__1ycBK","leftAlignText":"styles__leftAlignText__2w0Fv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ImageResize/styles.scss
// module id = 851
// module chunks = 0